

























































































































































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import Vue from "vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import KepatuhanIdentifikasiPasienStore from "@/store/modules/KepatuhanIdentifikasiPasienStore";
import KepatuhanIdentifikasiPasienService from "@/services/KepatuhanIdentifikasiPasienService";

// 24 unit dari template
const UNIT_OPTIONS = [
  "yudhistira","arjuna","bisma","gatotkaca","nakula","sadewa","pergiwati",
  "abimanyu","parikesit","kunthi","bima","baladewa","setyaki","rb","icu","iccu",
  "dewaruci_hcu","antasena_hd","ibs","onkologi","poliklinik","laboratorium","igd","radiologi"
].map(v => ({
  value: v,
  text: v.split("_").map(w => w[0].toUpperCase() + w.slice(1)).join("/")
}));

const PROFESI_OPTIONS = [
  { value: "perawat", text: "Perawat" },
  { value: "dokter_umum", text: "Dokter Umum" },
  { value: "dokter_spesialis", text: "Dokter Spesialis" },
  { value: "bidan", text: "Bidan" },
  { value: "apoteker", text: "Apoteker" },
  { value: "analis", text: "Analis Lab" },
  { value: "radiografer", text: "Radiografer" },
  { value: "ahli_gizi", text: "Ahli Gizi" },
  { value: "fisioterapis", text: "Fisioterapis" },
  { value: "lainnya", text: "Lainnya" }
];

const MOMEN_OPTIONS = [
  { value: "m1_obat", text: "M1 — Sebelum Obat" },
  { value: "m2_darah", text: "M2 — Sebelum Transfusi Darah" },
  { value: "m3_spesimen", text: "M3 — Sebelum Ambil Spesimen Lab" },
  { value: "m4_tindakan", text: "M4 — Sebelum Tindakan/Prosedur" },
  { value: "m5_diet", text: "M5 — Sebelum Pemberian Diet" }
];

const LANGKAH_LIST = [
  { key: "langkah_1_perkenalan", shortKey: "l1", short: "L1 — Perkenalan & jelaskan tindakan", label: "L1: Petugas memperkenalkan diri & jelaskan tindakan" },
  { key: "langkah_2_tanya_nama", shortKey: "l2", short: "L2 — Tanya nama lengkap", label: "L2: Minta pasien sebutkan nama lengkap (aktif)" },
  { key: "langkah_3_tanya_tanggal_lahir", shortKey: "l3", short: "L3 — Tanya tanggal lahir", label: "L3: Minta pasien sebutkan tanggal lahir" },
  { key: "langkah_4_cocok_gelang", shortKey: "l4", short: "L4 — Cocokkan dengan gelang", label: "L4: Cocokkan identitas dengan gelang (visual)" },
  { key: "langkah_5_cocok_rekam_medis", shortKey: "l5", short: "L5 — Cocokkan dgn RM/instruksi", label: "L5: Cocokkan dengan instruksi/rekam medis" },
  { key: "langkah_6_dokumentasi", shortKey: "l6", short: "L6 — Dokumentasi verifikasi", label: "L6: Dokumentasikan verifikasi (checklist/TTD)" }
];

interface ObsRow {
  id?: number;
  petugas_id: number | null;
  nama_petugas_pengumpul: string;
  tanggal_observasi: string;
  waktu_observasi: string;
  lokasi_spesifik: string;
  encounter_id: number | null;
  nama_pasien: string;
  no_rekam_medis: string;
  pasien_kategori: string | null;
  profesi: string;
  momen_verifikasi: string;
  min_2_identitas: string | null;
  verbal: string | null;
  visual: string | null;
  hasil: string | null;
  langkah_1_perkenalan: string | null;
  langkah_2_tanya_nama: string | null;
  langkah_3_tanya_tanggal_lahir: string | null;
  langkah_4_cocok_gelang: string | null;
  langkah_5_cocok_rekam_medis: string | null;
  langkah_6_dokumentasi: string | null;
  jumlah_langkah_patuh: number;
  kepatuhan_overall: string | null;
  gelang_terpasang: boolean;
  gelang_warna_utama: string | null;
  gelang_warna_benar: boolean;
  gelang_overlay_alergi: boolean;
  gelang_overlay_jatuh: boolean;
  gelang_overlay_dnr: boolean;
  gelang_terbaca_jelas: boolean;
  ada_pelanggaran_kritikal: boolean;
  keterangan: string;
}

interface RtlRow {
  id?: number;
  masalah_gap: string;
  analisa_akar_masalah: string;
  rencana_tindak_lanjut: string;
  penanggung_jawab_nama?: string;
  target_selesai?: string;
}

interface KtdRow {
  id?: number;
  observation_id?: number | null;
  tanggal_kejadian: string;
  tipe_ktd: string;
  severity: string;
  deskripsi: string;
  sudah_dilaporkan_ke_ikp: boolean;
  nomor_ikp?: string;
}

// -----------------------------------------------------------------------------
// Blank factory functions (module-level — supaya bisa dipanggil dari data())
// -----------------------------------------------------------------------------
function createBlankForm(): any {
  const today = localISODate();
  return {
    id: null as number | null,
    nomor_formulir: "",
    tanggal_observasi: today,
    waktu_mulai: "",
    waktu_selesai: "",
    shift: "pagi",
    unit_ruangan: "",
    unit_ruangan_nama: "",
    nama_pengisi_id: null as number | null,
    nama_pengisi: "",
    periode_agregat: "harian",
    target_momen: [] as string[],
    target_profesi: [] as string[],
    tindakan_obat: false,
    tindakan_diet: false,
    tindakan_transfusi: false,
    tindakan_spesimen: false,
    tindakan_prosedur: false,
    observations: [] as ObsRow[],
    rtls: [] as RtlRow[],
    ktd_events: [] as KtdRow[],
    kesimpulan: "",
    rekomendasi_umum: "",
    status: "draft",
    is_locked: false,
    is_pencatat_signed: false,
    is_verifikator_signed: false,
    is_kepala_unit_signed: false,
    next_sign_tier: "pencatat",
    kategori_kepatuhan: null as string | null,
    retention_until: "",
    signed_pencatat_nama: "",
    signed_pencatat_at: null as any,
    signed_verifikator_nama: "",
    signed_verifikator_at: null as any,
    signed_kepala_unit_nama: "",
    signed_kepala_unit_at: null as any
  };
}

function createBlankObs(): ObsRow {
  return {
    petugas_id: null,
    nama_petugas_pengumpul: "",
    tanggal_observasi: localISODate(),
    waktu_observasi: "",
    lokasi_spesifik: "",
    encounter_id: null,
    nama_pasien: "",
    no_rekam_medis: "",
    pasien_kategori: "dewasa",
    profesi: "perawat",
    momen_verifikasi: "m1_obat",
    min_2_identitas: null,
    verbal: null,
    visual: null,
    hasil: null,
    langkah_1_perkenalan: null,
    langkah_2_tanya_nama: null,
    langkah_3_tanya_tanggal_lahir: null,
    langkah_4_cocok_gelang: null,
    langkah_5_cocok_rekam_medis: null,
    langkah_6_dokumentasi: null,
    jumlah_langkah_patuh: 0,
    kepatuhan_overall: null,
    gelang_terpasang: true,
    gelang_warna_utama: null,
    gelang_warna_benar: true,
    gelang_overlay_alergi: false,
    gelang_overlay_jatuh: false,
    gelang_overlay_dnr: false,
    gelang_terbaca_jelas: true,
    ada_pelanggaran_kritikal: false,
    keterangan: ""
  };
}

function createBlankRtl(): RtlRow {
  return { masalah_gap: "", analisa_akar_masalah: "", rencana_tindak_lanjut: "", penanggung_jawab_nama: "", target_selesai: "" };
}

function createBlankKtd(): KtdRow {
  return {
    tanggal_kejadian: localISODate(),
    tipe_ktd: "",
    severity: "ringan",
    deskripsi: "",
    sudah_dilaporkan_ke_ikp: false,
    nomor_ikp: ""
  };
}

export default Vue.extend({
  name: "KepatuhanIdentifikasiPasienPage",

  components: { PersonAutoComplete },

  data() {
    return {
      outerTab: 0,
      wizardTab: 0,
      showForm: false,
      editingId: null as number | null,
      saving: false,
      signing: false,
      expandedObs: [0] as number[],

      form: createBlankForm(),

      filters: {
        bulan: new Date().getMonth() + 1,
        tahun: new Date().getFullYear(),
        unit_ruangan: "",
        shift: "",
        momen: "",
        kategori_kepatuhan: "",
        ada_ktd: "",
        status: "",
        status_target: "",
        search: ""
      },
      dashFilter: {
        bulan: new Date().getMonth() + 1,
        tahun: new Date().getFullYear(),
        unit_ruangan: ""
      },

      dialogSign: false,
      signTier: "" as "" | "pencatat" | "verifikator" | "kepala_unit",
      signPassword: "",

      snack: { show: false, color: "success", text: "" },

      unitOptions: UNIT_OPTIONS,
      profesiOptions: PROFESI_OPTIONS,
      momenOptions: MOMEN_OPTIONS,
      langkahList: LANGKAH_LIST,
      yaTidakNaOptions: [
        { value: "ya", text: "Ya" },
        { value: "tidak", text: "Tidak" },
        { value: "na", text: "N/A" }
      ],
      shiftOptions: [
        { value: "pagi", text: "Pagi (07-14)" },
        { value: "siang", text: "Siang (14-21)" },
        { value: "malam", text: "Malam (21-07)" }
      ],
      pasienKategoriOptions: [
        { value: "dewasa", text: "Dewasa" },
        { value: "anak", text: "Anak" },
        { value: "bayi", text: "Bayi" },
        { value: "ibu_hamil", text: "Ibu Hamil" },
        { value: "disabilitas", text: "Disabilitas" },
        { value: "non_responsif", text: "Non-Responsif" },
        { value: "lainnya", text: "Lainnya" }
      ],
      gelangWarnaOptions: [
        { value: "pink", text: "🌸 Pink (Perempuan)" },
        { value: "biru", text: "🔵 Biru (Laki-laki)" },
        { value: "putih", text: "⚪ Putih (Bayi belum bernama)" },
        { value: "lainnya", text: "Lainnya" }
      ],
      severityOptions: [
        { value: "ringan", text: "Ringan" },
        { value: "sedang", text: "Sedang" },
        { value: "berat", text: "Berat" },
        { value: "sentinel", text: "Sentinel" }
      ],
      kategoriOptions: [
        { value: "eksellen", text: "Eksellen (100%)" },
        { value: "baik", text: "Baik (≥95%)" },
        { value: "cukup", text: "Cukup (80-94%)" },
        { value: "kurang", text: "Kurang (<80%)" }
      ],
      kategoriList: [
        { value: "eksellen", text: "Eksellen", range: "= 100%" },
        { value: "baik", text: "Baik", range: "≥ 95%" },
        { value: "cukup", text: "Cukup", range: "80-94%" },
        { value: "kurang", text: "Kurang", range: "< 80%" }
      ],
      ktdFilterOptions: [
        { value: "true", text: "Ada KTD" },
        { value: "false", text: "Tidak Ada KTD" }
      ],
      bulanOptions: [
        { value: 1, text: "Januari" }, { value: 2, text: "Februari" }, { value: 3, text: "Maret" },
        { value: 4, text: "April" }, { value: 5, text: "Mei" }, { value: 6, text: "Juni" },
        { value: 7, text: "Juli" }, { value: 8, text: "Agustus" }, { value: 9, text: "September" },
        { value: 10, text: "Oktober" }, { value: 11, text: "November" }, { value: 12, text: "Desember" }
      ],
      tindakanList: [
        { key: "tindakan_obat", label: "Sebelum pemberian obat" },
        { key: "tindakan_diet", label: "Sebelum pemberian nutrisi/diet" },
        { key: "tindakan_transfusi", label: "Sebelum transfusi darah / produk darah" },
        { key: "tindakan_spesimen", label: "Sebelum pengambilan spesimen laboratorium" },
        { key: "tindakan_prosedur", label: "Sebelum tindakan/prosedur terapeutik & diagnostik" }
      ],
      tierList: [
        { role: "pencatat", label: "Petugas Pengisi", desc: "TTD oleh observator setelah observasi selesai dicatat." },
        { role: "verifikator", label: "Verifikator / PIC Mutu", desc: "TTD oleh PIC Mutu unit setelah validasi data." },
        { role: "kepala_unit", label: "Kepala Unit / Ruangan", desc: "TTD final — mengunci sesi." }
      ],
      tableHeaders: [
        { text: "No. Formulir", value: "nomor_formulir", sortable: false },
        { text: "Tanggal", value: "tanggal_observasi" },
        { text: "Shift", value: "shift" },
        { text: "Unit", value: "unit_ruangan_nama" },
        { text: "Event", value: "jumlah_momen_diobservasi", align: "center" },
        { text: "Patuh", value: "jumlah_patuh", align: "center" },
        { text: "Capaian", value: "capaian_persen", align: "center" },
        { text: "Kategori", value: "kategori_kepatuhan", align: "center" },
        { text: "KTD", value: "ada_kejadian_ktd_terkait", align: "center" },
        { text: "Workflow", value: "status", align: "center" },
        { text: "", value: "actions", sortable: false, align: "end" }
      ]
    };
  },

  computed: {
    store() { return KepatuhanIdentifikasiPasienStore; },
    formLocked(): boolean {
      return !!this.form.is_locked || ["verified", "approved", "closed"].includes(this.form.status);
    },

    ringkasan() {
      const obs = (this.form.observations || []) as ObsRow[];
      const total = obs.length;
      const benar = obs.filter(o => o.hasil === "benar").length;
      const tidak = obs.filter(o => o.hasil === "tidak").length;
      const patuh = obs.filter(o => o.kepatuhan_overall === "patuh").length;
      const na = obs.filter(o => o.kepatuhan_overall === "na").length;
      const denom3 = benar + tidak;
      const denom6 = total - na;
      const capaian3 = denom3 > 0 ? Math.round((benar / denom3) * 10000) / 100 : 0;
      const capaian6 = denom6 > 0 ? Math.round((patuh / denom6) * 10000) / 100 : 0;
      let kategori = "kurang";
      if (capaian3 >= 100) kategori = "eksellen";
      else if (capaian3 >= 95) kategori = "baik";
      else if (capaian3 >= 80) kategori = "cukup";
      return { total, benar, tidak, patuh, na, capaian3, capaian6, kategori };
    },

    breakdownMomen(): Record<string, any> {
      const obs = this.form.observations as ObsRow[];
      const result: Record<string, any> = {};
      MOMEN_OPTIONS.forEach(m => {
        const subset = obs.filter(o => o.momen_verifikasi === m.value);
        const p = subset.filter(o => o.kepatuhan_overall === "patuh").length;
        const tp = subset.filter(o => o.kepatuhan_overall === "tidak_patuh").length;
        const d = p + tp;
        result[m.value] = { observasi: subset.length, patuh: p, tidak_patuh: tp, persen: d > 0 ? Math.round(p / d * 10000) / 100 : null };
      });
      return result;
    },

    breakdownLangkah(): Record<string, any> {
      const obs = this.form.observations as ObsRow[];
      const result: Record<string, any> = {};
      LANGKAH_LIST.forEach(l => {
        const ya = obs.filter(o => (o as any)[l.key] === "ya").length;
        const tidak = obs.filter(o => (o as any)[l.key] === "tidak").length;
        const d = ya + tidak;
        result[l.shortKey] = { ya, tidak, persen: d > 0 ? Math.round(ya / d * 10000) / 100 : null };
      });
      return result;
    },

    breakdownProfesiRows(): any[] {
      const obs = this.form.observations as ObsRow[];
      const map: Record<string, any> = {};
      obs.forEach(o => {
        if (!o.profesi) return;
        if (!map[o.profesi]) map[o.profesi] = { profesi: o.profesi, observasi: 0, patuh: 0, tidak_patuh: 0 };
        map[o.profesi].observasi += 1;
        if (o.kepatuhan_overall === "patuh") map[o.profesi].patuh += 1;
        if (o.kepatuhan_overall === "tidak_patuh") map[o.profesi].tidak_patuh += 1;
      });
      return Object.values(map).map((r: any) => {
        const d = r.patuh + r.tidak_patuh;
        r.persen = d > 0 ? Math.round(r.patuh / d * 10000) / 100 : 0;
        return r;
      });
    }
  },

  mounted() {
    this.loadSessions();
    this.loadDashboard();
  },

  watch: {
    outerTab(v: number) {
      if (v === 1) this.loadDashboard();
    }
  },

  methods: {
    onUnitChange() {
      const found = UNIT_OPTIONS.find(u => u.value === this.form.unit_ruangan);
      this.form.unit_ruangan_nama = found ? found.text : "";
    },

    addObservationRow() {
      this.form.observations.push(createBlankObs());
      this.expandedObs.push(this.form.observations.length - 1);
    },

    removeObservationRow(idx: number) {
      this.form.observations.splice(idx, 1);
      this.expandedObs = this.expandedObs.filter(i => i !== idx).map(i => i > idx ? i - 1 : i);
    },

    addRtlRow() { this.form.rtls.push(createBlankRtl()); },
    removeRtlRow(idx: number) { this.form.rtls.splice(idx, 1); },

    addKtdRow() { this.form.ktd_events.push(createBlankKtd()); },
    removeKtdRow(idx: number) { this.form.ktd_events.splice(idx, 1); },

    /**
     * Apply derivation rules (mirror of backend's applyComputedFields).
     * Run on every langkah change so UI shows live feedback.
     */
    recomputeLocal(obs: ObsRow) {
      const langkahKeys = LANGKAH_LIST.map(l => l.key);

      // Derive 3 komponen from 6 langkah
      obs.min_2_identitas = (obs.langkah_2_tanya_nama === "ya" && obs.langkah_3_tanya_tanggal_lahir === "ya") ? "ya" : "tidak";
      obs.verbal = (obs.langkah_2_tanya_nama === "ya" || obs.langkah_3_tanya_tanggal_lahir === "ya") ? "ya" : "tidak";
      obs.visual = (obs.langkah_4_cocok_gelang === "ya") ? "ya" : "tidak";

      // Compute hasil (template)
      if (obs.min_2_identitas && obs.verbal && obs.visual) {
        obs.hasil = (obs.min_2_identitas === "ya" && (obs.verbal === "ya" || obs.visual === "ya")) ? "benar" : "tidak";
      } else {
        obs.hasil = null;
      }

      // jumlah_langkah_patuh
      obs.jumlah_langkah_patuh = langkahKeys.filter(k => (obs as any)[k] === "ya").length;

      // kepatuhan_overall
      const anyTidak = langkahKeys.some(k => (obs as any)[k] === "tidak");
      const anyNa = langkahKeys.some(k => (obs as any)[k] === "na");
      const allYa = langkahKeys.every(k => (obs as any)[k] === "ya");
      if (anyTidak) obs.kepatuhan_overall = "tidak_patuh";
      else if (allYa) obs.kepatuhan_overall = "patuh";
      else if (anyNa) obs.kepatuhan_overall = "na";
      else obs.kepatuhan_overall = null;

      // Flag kritikal
      const tidakTanyaNama = obs.langkah_2_tanya_nama === "tidak";
      const tidakTanyaTgl = obs.langkah_3_tanya_tanggal_lahir === "tidak";
      obs.ada_pelanggaran_kritikal =
        (!obs.gelang_terpasang && obs.pasien_kategori !== "non_responsif") ||
        (tidakTanyaNama && tidakTanyaTgl) ||
        (obs.gelang_terpasang && !obs.gelang_terbaca_jelas);
    },

    async loadSessions() {
      this.store.setFilters(this.filters);
      await this.store.loadSessions(this.filters);
    },

    async loadDashboard() {
      await this.store.loadDashboard(this.dashFilter);
    },

    onPageChange(page: number) {
      this.store.loadSessions({ ...this.filters, page });
    },

    tambahBaru() {
      this.editingId = null;
      this.form = createBlankForm();
      this.wizardTab = 0;
      this.showForm = true;
    },

    async openDetail(item: any) {
      this.editingId = item.id;
      await this.store.loadSession(item.id);
      const data = this.store.currentSession;
      if (data) {
        this.form = {
          ...createBlankForm(),
          ...data,
          observations: (data.observations || []).map((o: any) => ({ ...o })),
          rtls: (data.rtls || []).map((r: any) => ({ ...r })),
          ktd_events: (data.ktd_events || []).map((k: any) => ({ ...k }))
        };
        // Run local recompute on each obs to ensure UI reflects computed values
        this.form.observations.forEach((o: ObsRow) => this.recomputeLocal(o));
      }
      this.wizardTab = 0;
      this.showForm = true;
    },

    closeForm() {
      this.showForm = false;
      this.editingId = null;
      this.form = createBlankForm();
      this.loadSessions();
    },

    openPdf(item: any) {
      const url = KepatuhanIdentifikasiPasienService.getPdfUrl(item.id);
      window.open(url, "_blank");
    },

    async confirmDelete(item: any) {
      if (!window.confirm(`Hapus sesi ${item.nomor_formulir}?`)) return;
      try {
        await this.store.deleteSession(item.id);
        this.toast("Sesi dihapus", "success");
        this.loadSessions();
      } catch { /* error alert shown */ }
    },

    async simpan() {
      if (!this.form.tanggal_observasi || !this.form.shift || !this.form.unit_ruangan || !this.form.nama_pengisi) {
        this.toast("Lengkapi Data Umum (tab A) dulu", "error");
        this.wizardTab = 0;
        return;
      }
      if (!this.form.observations.length) {
        this.toast("Minimal 1 event observasi wajib diisi (tab B)", "error");
        this.wizardTab = 1;
        return;
      }
      const incomplete = this.form.observations.some((o: ObsRow) =>
        !o.profesi || !o.momen_verifikasi
        || !o.langkah_1_perkenalan || !o.langkah_2_tanya_nama || !o.langkah_3_tanya_tanggal_lahir
        || !o.langkah_4_cocok_gelang || !o.langkah_5_cocok_rekam_medis || !o.langkah_6_dokumentasi
      );
      if (incomplete) {
        this.toast("Semua event wajib mengisi profesi, momen, dan 6 langkah", "error");
        this.wizardTab = 1;
        return;
      }

      this.saving = true;
      try {
        const payload: any = { ...this.form };
        // Strip fields computed server-side
        delete payload.id;
        delete payload.kategori_kepatuhan;
        delete payload.status;
        delete payload.is_locked;
        delete payload.next_sign_tier;
        delete payload.is_pencatat_signed;
        delete payload.is_verifikator_signed;
        delete payload.is_kepala_unit_signed;
        delete payload.retention_until;

        payload.observations = this.form.observations.map((o: ObsRow) => {
          const { id, hasil, kepatuhan_overall, jumlah_langkah_patuh, ada_pelanggaran_kritikal, ...rest } = o as any;
          return rest;
        });
        payload.rtls = this.form.rtls
          .filter((r: RtlRow) => r.masalah_gap || r.analisa_akar_masalah || r.rencana_tindak_lanjut)
          .map(({ id, ...rest }: any) => rest);
        payload.ktd_events = this.form.ktd_events
          .filter((k: KtdRow) => k.deskripsi)
          .map(({ id, ...rest }: any) => rest);

        let result: any;
        if (this.editingId) {
          result = await this.store.updateSession({ id: this.editingId, data: payload });
        } else {
          result = await this.store.createSession(payload);
          this.editingId = result?.id;
        }
        if (result) {
          this.form = {
            ...createBlankForm(),
            ...result,
            observations: (result.observations || []).map((o: any) => ({ ...o })),
            rtls: (result.rtls || []).map((r: any) => ({ ...r })),
            ktd_events: (result.ktd_events || []).map((k: any) => ({ ...k }))
          };
        }
        this.toast("Berhasil disimpan", "success");
      } catch { /* error alert */ }
      finally { this.saving = false; }
    },

    tierStatus(role: string) {
      const f = this.form as any;
      return {
        signed: !!f[`is_${role}_signed`],
        nama: f[`signed_${role}_nama`],
        at: f[`signed_${role}_at`]
      };
    },

    bukaDialogSign(tier: string) {
      this.signTier = tier as any;
      this.signPassword = "";
      this.dialogSign = true;
    },

    async konfirmasiSign() {
      if (!this.signPassword) { this.toast("Password wajib diisi", "error"); return; }
      if (!this.editingId || !this.signTier) return;

      this.signing = true;
      try {
        let result: any;
        const payload = { id: this.editingId, password: this.signPassword };
        if (this.signTier === "pencatat") result = await this.store.signPencatat(payload);
        else if (this.signTier === "verifikator") result = await this.store.signVerifikator(payload);
        else if (this.signTier === "kepala_unit") result = await this.store.signKepalaUnit(payload);

        if (result) {
          this.form = {
            ...createBlankForm(),
            ...result,
            observations: (result.observations || []).map((o: any) => ({ ...o })),
            rtls: (result.rtls || []).map((r: any) => ({ ...r })),
            ktd_events: (result.ktd_events || []).map((k: any) => ({ ...k }))
          };
        }
        this.dialogSign = false;
        this.toast("Berhasil ditandatangani", "success");
      } catch { /* error alert */ }
      finally { this.signing = false; }
    },

    // --- Labels & colors ---
    formatTanggal(v: string): string {
      if (!v) return "-";
      return new Date(v).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
    },
    formatDate(v: any): string {
      if (!v) return "-";
      return new Date(v).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },
    labelShift(v: string) { return ({ pagi: "Pagi", siang: "Siang", malam: "Malam" } as any)[v] || v; },
    labelStatus(v: string) { return ({ draft: "Draft", submitted: "Submitted", verified: "Verified", approved: "Approved", closed: "Closed" } as any)[v] || v; },
    labelMomen(v: string) { return MOMEN_OPTIONS.find(m => m.value === v)?.text || v || ""; },
    labelProfesi(v: string) { return PROFESI_OPTIONS.find(p => p.value === v)?.text || v || ""; },
    labelKategori(v: string) { return ({ eksellen: "Eksellen", baik: "Baik", cukup: "Cukup", kurang: "Kurang" } as any)[v] || "-"; },
    labelKepatuhan(v: string | null) { return v ? ({ patuh: "✔ Patuh", tidak_patuh: "✘ Tidak Patuh", na: "N/A" } as any)[v] : ""; },
    labelTier(v: string) { return ({ pencatat: "Petugas Pengisi", verifikator: "Verifikator/PIC Mutu", kepala_unit: "Kepala Unit/Ruangan" } as any)[v] || v; },
    kategoriColor(v: string | null) {
      return ({ eksellen: "green darken-1", baik: "green lighten-1", cukup: "orange", kurang: "red" } as any)[v ?? ""] || "grey";
    },
    kepatuhanColor(v: string | null) {
      return ({ patuh: "green", tidak_patuh: "red", na: "grey" } as any)[v ?? ""] || "grey";
    },
    severityColor(v: string) {
      return ({ ringan: "yellow darken-2", sedang: "orange", berat: "red darken-2", sentinel: "black" } as any)[v] || "grey";
    },
    heatmapCellStyle(v: number | null) {
      if (v === null || v === undefined) return "background: #f5f5f5; color: #999;";
      if (v >= 95) return "background: #c8e6c9; color: #1b5e20; font-weight: bold;";
      if (v >= 80) return "background: #fff9c4; color: #f57f17;";
      return "background: #ffcdd2; color: #b71c1c; font-weight: bold;";
    },

    toast(text: string, color: "success" | "error" | "info" = "info") {
      this.snack = { show: true, color, text };
    }
  }
});
